import React, { useContext } from 'react';
import styles from './PMSSelector.styles';
import { Select } from 'antd';
import { AppContext } from '../../../../App.context';
import getPMSLogo from 'utils/getPMSLogo';

export default function PMSSelector({ row, pmsList, hotelStatus, actions }) {
  const { Option } = Select;
  const {
    appActions: { translate },
    appState,
  } = useContext(AppContext);

  const pmsSuscribed = pmsList.find(pms => pms.id == row.pmsIdSuscribed)?.name;
  const pmsCheckin = row.pmsCheckin;
  const effectivePmsCheckin =
    hotelStatus === 6 && !pmsSuscribed && !pmsCheckin ? 'NoIntegration' : pmsCheckin;
  const pmsSelectionName =
    effectivePmsCheckin !== 'NoIntegration' ? effectivePmsCheckin : pmsSuscribed || 'NoIntegration';
  const pmsCurrentSelection = pmsList.find(pms => pms.id == actions.getSelectedPms(row.id))?.name;
  const showLogo = pmsSelectionName || pmsCurrentSelection;

  const pmsTranslation = pmsSelectionName
    ? translate(`pmsName.${pmsSelectionName.toLowerCase()}`)
    : '';
  const pmsName = pmsTranslation.includes('.') ? pmsSelectionName : pmsTranslation;
  const pmsSelectValue = actions.getSelectedPms(row.id) || pmsName;

  actions.setPmsSaved(row.id, effectivePmsCheckin);

  return (
    <div style={styles.container}>
      <div style={styles.selector}>
        <Select
          onChange={option => actions.setPmsSelected(row.id, option)}
          bordered={false}
          style={{ width: '100%' }}
          disabled={!(['admin', 'owner'].includes(appState.role) || appState.superUser)}
          value={pmsSelectValue && pmsSelectValue !== '' ? pmsSelectValue : null}
          placeholder={translate('pmsScreen.defaultSelectorValue')}
        >
          {pmsList
            ?.slice()
            .sort((a, b) => {
              const labelA = translate(`pmsName.${a.name.toLowerCase()}`);
              const labelB = translate(`pmsName.${b.name.toLowerCase()}`);
              const nameA = labelA.includes('.') ? a.name : labelA;
              const nameB = labelB.includes('.') ? b.name : labelB;
              return nameA.localeCompare(nameB);
            })
            ?.map((pms, index) => {
              const pmsTranslation = translate(`pmsName.${pms.name.toLowerCase()}`);
              const pmsName = pmsTranslation.includes('.') ? pms.name : pmsTranslation;

              return (
                <Option key={index} value={pms.id}>
                  {pmsName}
                </Option>
              );
            })}
        </Select>
      </div>
      {showLogo && (
        <img
          src={getPMSLogo(pmsCurrentSelection || pmsSelectionName)}
          style={{ alignSelf: 'center', height: 36 }}
        />
      )}
    </div>
  );
}
